import { SVGProps } from "react";

const Export = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.2701 8.5C15.9185 8.72143 17 10.0429 17 12.9357V13.0286C17 16.2214 15.6831 17.5 12.3946 17.5H7.60536C4.31687 17.5 3 16.2214 3 13.0286V12.9357C3 10.0643 4.06674 8.74286 6.67105 8.50714"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 12.5V4.5"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5.5L10 3.5L8 5.5"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Export;
